import {
  Category,
  ValuesAccommodation,
  ValuesAccommodationPublic,
  ValuesBuilding,
  ValuesBuildingHeating,
  ValuesCargo,
  ValuesCateringBeverage,
  ValuesCateringMeal,
  ValuesDigital,
  ValuesEnergy,
  ValuesEquipment,
  ValuesGenerator,
  ValuesMobility,
  ValuesMobilityPublic,
  ValuesNonRecyclableWaste,
  ValuesOfficeSuppliesNew,
  ValuesOfficeSuppliesRefurbish,
  ValuesRecyclableWaste,
  ValuesScenographyNoRecyclable,
  ValuesScenographyRecyclable,
  ValuesTeamMobility,
  ValuesWater,
} from '@/domain/impact-co2/entities/question.entity';

const accommodationKeys: (keyof ValuesAccommodation)[] = [
  'accommodationType',
  'numberOfNights',
];

const accommodationPublicKeys: (keyof ValuesAccommodationPublic)[] = [
  'accommodationType',
  'numberOfNights',
  'guestCount',
];

const buildingKeys: (keyof ValuesBuilding)[] = [
  'hasBuildingImpact',
  'buildingCarbonImpactPerDay',
  'numberOfDaysOfUse',
];
const cargoKeys: (keyof ValuesCargo)[] = [
  'transportationMode',
  'weight',
  'travelDistance',
];

const cateringBeverageKeys: (keyof ValuesCateringBeverage)[] = [
  'beverageType',
  'beverageCount',
];

const cateringMealKeys: (keyof ValuesCateringMeal)[] = [
  'mealType',
  'mealCount',
];

const digitalKeys: (keyof ValuesDigital)[] = ['dataUsage', 'videoViews'];

const energyKeys: (keyof ValuesEnergy)[] = [
  'energyType',
  'energyConsumptionQuantity',
];

const equipmentKeys: (keyof ValuesEquipment)[] = [
  'rentedEquipmentType',
  'rentalDays',
  'quantity',
];

const generatorKeys: (keyof ValuesGenerator)[] = [
  'hasGenerator',
  'fuelType',
  'fuelConsumption',
];

const mobilityKeys: (keyof ValuesMobility)[] = [
  'transportationMode',
  'passengerCount',
  'travelDistance',
];

const mobilityPublicKeys: (keyof ValuesMobilityPublic)[] = [
  'transportationMode',
  'passengerCount',
  'travelDistance',
  'departurePoint',
];

const nonRecyclableWasteKeys: (keyof ValuesNonRecyclableWaste)[] = [
  'nonRecyclableWasteType',
  'nonRecyclableWasteQuantity',
];

const recyclableWasteKeys: (keyof ValuesRecyclableWaste)[] = [
  'recyclableWasteType',
  'recyclableWasteQuantity',
];

const scenographieNoRecyclableKeys: (keyof ValuesScenographyNoRecyclable)[] = [
  'scenographieNoRecyclableType',
  'quantity',
];

const scenographieRecyclableKeys: (keyof ValuesScenographyRecyclable)[] = [
  'scenographieRecyclableType',
  'quantity',
];

const buildingHeatingKeys: (keyof ValuesBuildingHeating)[] = [
  'buildingHeatingType',
  'buildingSize',
  'numberOfMonthsOfUse',
];

const officeSuppliesNewKeys: (keyof ValuesOfficeSuppliesNew)[] = [
  'officeSuppliesNewType',
  'count',
];

const officeSuppliesRefurbishKeys: (keyof ValuesOfficeSuppliesRefurbish)[] = [
  'officeSuppliesRefurbishType',
  'count',
];

const teamMobilityKeys: (keyof ValuesTeamMobility)[] = [
  'transportationMode',
  'passengerCount',
  'travelDistance',
  'numberOfDays',
];

const waterKeys: (keyof ValuesWater)[] = ['waterConsumptionVolume'];

export const extraColumnsByCategory: Record<Category, string[]> = {
  ACCOMMODATION: accommodationKeys,
  ACCOMMODATION_PUBLIC: accommodationPublicKeys,
  BUILDING: buildingKeys,
  CARGO: cargoKeys,
  CATERING_BEVERAGE: cateringBeverageKeys,
  CATERING_MEAL: cateringMealKeys,
  DIGITAL: digitalKeys,
  ENERGY: energyKeys,
  EQUIPMENT: equipmentKeys,
  GENERATOR: generatorKeys,
  MOBILITY: mobilityKeys,
  MOBILITY_PUBLIC: mobilityPublicKeys,
  NON_RECYCLABLE_WASTE: nonRecyclableWasteKeys,
  RECYCLABLE_WASTE: recyclableWasteKeys,
  SCENOGRAPHY_NO_RECYCLABLE: scenographieNoRecyclableKeys,
  SCENOGRAPHY_RECYCLABLE: scenographieRecyclableKeys,
  BUILDING_HEATING: buildingHeatingKeys,
  OFFICE_SUPPLIES_NEW: officeSuppliesNewKeys,
  OFFICE_SUPPLIES_REFURBISH: officeSuppliesRefurbishKeys,
  TEAM_MOBILITY: teamMobilityKeys,
  WATER: waterKeys,
};
